import React from "react";
import Header from "../../Components/Header";
import Category from "../../Components/Category";
import CategoryHeading from "../../Components/CategoryHeading";
import Card from "../../Components/Card";
import Image from "../../Assets/Images/Contactor/Abb Contactor.jpg";
import Image1 from "../../Assets/Images/Contactor/All Types of  Contactor.jpg";
import Image2 from "../../Assets/Images/Contactor/Fuji Contactor.jpg";
import Image3 from "../../Assets/Images/Contactor/Simens Contactor.jpg";
import Image4 from "../../Assets/Images/Contactor/Telemecanique Contactor.jpg";
import Footer from "../../Components/Footer/indes";
import "./Contactor.css";

function Contactor() {
  return (
    <>
      <div style={{ height: 80 }}>
        <Header />
      </div>

      <Category />
      <CategoryHeading Title={"Our Contactor"} />

      <div className="my-cards">
        <Card Image={Image} Title={"ABB Contactor"} />
        <Card Image={Image1} Title={"ALL Types of Contactor"} />
        <Card Image={Image2} Title={"FujiContactor"} />
        <Card Image={Image3} Title={"Siemens Contactor"} />
        <Card Image={Image4} Title={"Telemecanique Contactor"} />
      </div>
      <Footer />
    </>
  );
}

export default Contactor;
